import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "box-login shadow" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { class: "send btn btn-primary" }
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = { class: "send btn btn-primary" }

import store from "@/store";
import { computed, onMounted, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { MD5 } from "crypto-js";
import { toast } from "@/common/utils/toast";
import { maskNumber } from "@/common/utils/mask";

import { baseInput, baseCode, svgIcon } from "@/common/components";

import {
  userRecoverValid,
  userRecoverPassword,
  userRecoverCheckEmail,
} from "@/common/api/rest/user";

import type { UserRecoverType } from "@/common/types/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'valid',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const hash = computed(() => {
  try {
    const decode = window.atob(String(route.query.hash));
    return JSON.parse(decode);
  } catch (_) {
    return null;
  }
});

const hashEmail = computed(() => hash.value?.email);
const hashCode = computed(() => hash.value?.code);

const payload = ref<UserRecoverType>({
  code: "",
  email: "",
  password: "",
});

const confirmPassword = ref("");

const error = ref<{ [key: string]: string }>({});
const step = ref(1);

const interval = ref();
const passwordShow = ref(false);
const ConfirmPasswordShow = ref(false);

function isCodeValid() {
  const { code, email, password } = payload.value;

  error.value = {};

  const codeLength = code?.trim().length || 0;
  if (codeLength === 0) error.value.code = t("error.required");
  if (codeLength > 0 && codeLength < 5)
    error.value.code = t("error.min", { min: 5 });

  return Object.keys(error.value).length === 0;
}

function isPasswordValid() {
  const { password } = payload.value;

  error.value = {};

  if (password?.trim().length === 0) error.value.password = t("error.required");

  if (confirmPassword.value.trim().length === 0)
    error.value.confirm = t("error.required");

  if (password !== confirmPassword.value)
    error.value.confirm = t("error.not_equal");

  return Object.keys(error.value).length === 0;
}

function back() {
  router.push("/auth/recover");
}

function nextStep() {
  router.push({
    path: "/auth/recover/valid",
    query: {
      hash: window.btoa(
        JSON.stringify({
          email: payload.value.email,
          code: payload.value.code,
        })
      ),
    },
  });
}

function submitCode() {
  if (!isCodeValid()) return;

  userRecoverValid(payload.value)
    .then((response) => {
      const { success, message } = response;
      if (success) {
        toast({ message: message, type: "success" });
        nextStep();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function submitPassword() {
  if (!isPasswordValid() || !payload.value.password) return;

  userRecoverPassword({
    ...payload.value,
    password: MD5(payload.value.password).toString(),
  })
    .then((response) => {
      const { success, message } = response;
      if (success) {
        toast({ message: message, type: "success" });
        router.push("/auth/login");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watchEffect(() => {
  if (hashEmail.value) payload.value.email = hashEmail.value;

  if (hashCode.value) {
    payload.value.code = hashCode.value;
    step.value = 2;
    clearTimeout(interval.value);
  }
});

onBeforeRouteLeave(() => {
  clearTimeout(interval.value);
});

onMounted(() => {
  interval.value = setInterval(async () => {
    await userRecoverCheckEmail();
  }, 25000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/images/logo.png')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (step.value === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.labels.code").toUpperCase()), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("common.texts.input_code")), 1),
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (submitCode()), ["prevent"]))
              }, [
                _createVNode(_unref(baseCode), {
                  modelValue: payload.value.code,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((payload.value.code) = $event)),
                    _cache[1] || (_cache[1] = ($event: any) => (error.value.code = ''))
                  ],
                  placeholder: "00000",
                  background: "#f1f1f1",
                  minLength: "5",
                  maxLength: "5",
                  mask: _unref(maskNumber)
                }, _createSlots({ _: 2 }, [
                  (error.value.code)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.code), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "mask"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", _hoisted_8, _toDisplayString(_unref(t)("common.labels.send")?.toUpperCase()), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "back btn btn-sm btn-default",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (back()))
                  }, _toDisplayString(_unref(t)("common.labels.back")?.toUpperCase()), 1)
                ])
              ], 32)
            ], 64))
          : _createCommentVNode("", true),
        (step.value === 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.labels.new_password").toUpperCase()), 1),
              _createElementVNode("form", {
                onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (submitPassword()), ["prevent"]))
              }, [
                _createVNode(_unref(baseInput), {
                  modelValue: payload.value.password,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.password) = $event)),
                  placeholder: _unref(t)('common.placeholders.password'),
                  type: passwordShow.value ? 'text' : 'password',
                  background: "#f1f1f1",
                  maxLength: "50"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.password")), 1)
                  ]),
                  sufix: _withCtx(() => [
                    (passwordShow.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pointer",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (passwordShow.value = false))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye",
                            size: "1.5rem"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "pointer",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (passwordShow.value = true))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye-closed",
                            size: "1.5rem"
                          })
                        ]))
                  ]),
                  _: 2
                }, [
                  (error.value.password)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.password), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "placeholder", "type"]),
                _createVNode(_unref(baseInput), {
                  modelValue: confirmPassword.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((confirmPassword).value = $event)),
                  placeholder: _unref(t)('common.placeholders.password'),
                  type: ConfirmPasswordShow.value ? 'text' : 'password',
                  background: "#f1f1f1",
                  maxLength: "50"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.confirm_password")), 1)
                  ]),
                  sufix: _withCtx(() => [
                    (ConfirmPasswordShow.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pointer",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (ConfirmPasswordShow.value = false))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye",
                            size: "1.5rem"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "pointer",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (ConfirmPasswordShow.value = true))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye-closed",
                            size: "1.5rem"
                          })
                        ]))
                  ]),
                  _: 2
                }, [
                  (error.value.confirm)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.confirm), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "placeholder", "type"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", _hoisted_10, _toDisplayString(_unref(t)("common.labels.save")?.toUpperCase()), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "back btn btn-sm btn-default",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (back()))
                  }, _toDisplayString(_unref(t)("common.labels.back")?.toUpperCase()), 1)
                ])
              ], 32)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})